<template>
    <div>
      <!-- NAVBAR -->
      <my-navbar :controller="controller" />
      <!-- HEADER -->
      <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
        <div class="container-fluid">
          <div class="header-body">
            <div class="row">
              <!-- CONTENIDO HEADER -->
                <div class="col-lg-7 col-md-10">
                  <h1 class="display-3 text-white">{{ controller.title }}</h1>
                  <p class="text-white mt-0 mb-5">Para comenzar, busca un cliente en el listado</p>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- CONTENT -->
      <div class="container-fluid mt--7">
            <div class="row justify-content-center">
              <div class="col-md-4">
                <div class="card card-profile card-search shadow">
                  <my-spinner :loading="loading" />
                  <SearchDealer :inputData.sync="client_" :options="options"/>
                </div>
              </div>
              <div class="col-md-8">
                <div class="card card-client shadow" v-show="!showForm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-12">
                        <h4 class="client-name">No hay resultados</h4>
                        <h5 class="text-center text-muted">Seleccione una automotora del listado</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card card-client shadow mb-4" v-if="showForm">
                  <my-spinner :loading="loading"/>
                  <div class="card-body">
                      
                      <DealerHeader v-if="client" :dealer="client" :isActive="isActive" :loadingStatus.sync="loadingStatus" :count="listingCount" :loading="loading"/>

                      <div v-if="client && client.hasCP" class="actions">
                        <hr class="m-0 my-3">
                        <p>Acciones</p>
                        <div class="m-2" v-if="listingCount > 0">
                          <inventory-button  :identifier="client.identifier" :actions="actions" :special="authObj.setSpecialsAccess(this.$route.name, 'btnBloquearPublicaciones')"></inventory-button>
                        </div>
                      </div>

                  </div>
                </div>

                <dealer-users v-if="showForm && client && client.hasCP" 
                :loadingStatus.sync="loadingStatus"
                :isActive.sync="isActive"
                :dealer="client"
                :actions="actions"
                :special="authObj.setSpecialsAccess(this.$route.name, 'btnBloquearCliente')"></dealer-users>

              </div>
            </div>
      </div>
    </div>
</template>
<script>
import _ from "underscore";
import vSelect from "vue-select";
import utils from "@/helpers/utils";
import Auth from "@/helpers/middleware";
import sysMsgs from "@/helpers/system.message";
import clientesServices from "@/services/dealers.services";
import oneSearchServices from "@/services/oneSearch.services";	

import DealerHeader from './DealerHeader';
import DealerUsers from './DealerUsers.vue';
import InventoryButton from './InventoryButton';

export default {
  name: "clientes",
  components: {
    vSelect, DealerHeader,
    DealerUsers, InventoryButton
  },
  data() {
    return {
      loading: false,
      client_: null,
      options: {
        selectData: true
      },
      isActive: false,
      showForm: false,
      inventory: [],
      listingCount: 0,
      loadingStatus: null,
      clients: [],
      clientstmp: [],
      client: null,
      actions: Auth.getActions(this.$route.name),
      specials: Auth.getSpecialsAccess(this.$route.name),
      authObj: Auth,
      controller: {
        title: "Clientes",
        mainRouter: "/clientes"
      },
    };
  },
  watch: {
    client_: {
      deep: true,
      handler(data) {
        if (data) {
          this.getDealer(data);
          this.showForm = true;
        } else {
          this.showForm = false;
        }
      }
    },
    client: {
      deep: true,
      handler(data) {          
        this.loadingStatus = null;
        if (data == null) {
          this.listingCount = 0;
          this.clientstmp = this.clients;
        } else {
          this.getListingCount();
        }
      }
    }
  },
  methods: {
    getDealer(value) {
      if (!value) return;
      this.loading = true;
      this.isActive = false;
      this.client = null;
      clientesServices.general.getDealer(value.cod_cliente).then(response => {
        this.client = response.data;
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        console.log('Component: clientes, FN: getDealer', error.message);
        sysMsgs.getMessage("Error al consultar información del dealer.", "error");
      });
    },
    getListingCount() {
      this.loading = true;
      oneSearchServices.search.dealerAds(this.client.id).then(data => {
        this.listingCount = data && data.data ? data.data.count : 0;
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        console.log('Component: clientes, FN: getListingCount', error.message);
        sysMsgs.getMessage("Error al consultar avisos del dealer.", "error");
      });
    }
  }
};
</script>